import { Card } from "antd";
import styled from "styled-components";

export const MovieContainer = styled(Card)`
  width: 300px;
  margin: 20px;
`;
